import React, { ReactElement } from 'react'
import type {
    TagContextProps,
    DataLayerAction,
    DataLayerInput
} from '@corratech/pylot-tag-manager/src/TagContext.d'
import { TrackUrlChange } from './TrackUrlChange'
import { TrackUserData } from './TrackUserData'
import { TrackUserCustomData } from './TrackUserCustomData'
import { TrackCartState } from './TrackCartState'
import { InitScripts } from './InitScripts'
import { TrackCheckoutSteps } from './TrackCheckoutSteps'

export const TagContext = React.createContext({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dataLayerAction: (data: DataLayerInput) => {
        console.log('Data layer not initialized')
    }
})
TagContext.displayName = 'TagContext'

export const TagContextInit = ({
    handlers = [],
    scripts = [],
    children
}: TagContextProps): ReactElement<any, any> | null => {
    const dataLayerAction: DataLayerAction = (data) => {
        handlers.map((handler: DataLayerAction) => {
            try {
                handler(data)
            } catch (e) {
                console.log(e)
            }
        })
    }

    return (
        <>
            <InitScripts scripts={scripts} />
            <TagContext.Provider value={{ dataLayerAction }}>
                <TrackUrlChange dataLayerAction={dataLayerAction} />
                <TrackUserData dataLayerAction={dataLayerAction} />
                <TrackCartState dataLayerAction={dataLayerAction} />
                <TrackUserCustomData dataLayerAction={dataLayerAction} />
                <TrackCheckoutSteps />
                {children}
            </TagContext.Provider>
        </>
    )
}

export const useDataLayerAction = (): DataLayerAction => {
    const { dataLayerAction } = React.useContext(TagContext)
    return dataLayerAction
}
